import React from "react";

function Icon(data) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={data.w} height={data.h}>
        <path fillRule="evenodd" d="M23 11.997c0 3.072-.292 4.96-.975 6.131-.69 1.25-1.498 1.643-3.147 1.758-1.163.068-4.083.114-6.875.114-2.799 0-5.72-.046-6.894-.114-1.634-.115-2.442-.508-3.131-1.744C1.293 16.948 1 15.052 1 12.008c0-3.06.291-4.947.972-6.145.698-1.253 1.52-1.65 3.139-1.745C6.231 4.043 8.997 4 12.003 4c3 0 5.763.043 6.875.118 1.63.095 2.45.491 3.142 1.74.69 1.202.98 3.08.98 6.14ZM20.283 6.85c-.323-.585-.512-.677-1.53-.736-1.06-.072-3.798-.114-6.75-.114-2.959 0-5.698.042-6.766.114-1.009.06-1.2.152-1.522.73C3.248 7.665 3 9.268 3 11.996c0 2.73.249 4.342.719 5.16.317.57.507.662 1.518.733 1.112.065 4.005.11 6.766.11 2.754 0 5.646-.045 6.747-.11 1.024-.071 1.211-.163 1.536-.749.466-.8.714-2.403.714-5.133 0-2.75-.246-4.344-.717-5.158ZM10 9l5 3-5 3V9Z" />
    </svg>

  );
}

export default Icon;
